import ReservationsInfo from './ReservationsInfo';

export default ReservationsInfo;
